import React from "react";
import { Link } from "react-router-dom";
import ComingSoon from "../pages/ComingSoon";

function AdminSetting() {
  const settingItems = [
    // {
    //   title: "Change Password",
    //   desc: "Update your account security credentials",
    //   icon: "🔐",
    //   path: "/user/changePassword",
    //   color: "#e0e7ff",
    //   textColor: "#4338ca",
    // },
    {
      title: "Security Settings",
      desc: "Manage two-factor and session logs",
      icon: "🛡️",
      path: "/user/security",
      color: "#dcfce7",
      textColor: "#15803d",
    },
  ];

  return (

<ComingSoon type="settings" />

    // <div
    //   style={{
    //     padding: "30px 15px",
    //     maxWidth: "800px",
    //     margin: "0 auto",
    //   }}
    // >
    //   {/* Heading */}
    //   <h3
    //     style={{
    //       fontWeight: "bold",
    //       marginBottom: "5px",
    //       color: "#6366f1",
    //     }}
    //   >
    //     Settings
    //   </h3>

    //   <p
    //     style={{
    //       color: "#fff",
    //       marginBottom: "25px",
    //     }}
    //   >
    //     Manage your portal preferences and security
    //   </p>

    //   {/* List */}
    //   <div>
    //     {settingItems.map((item, index) => (
    //       <Link
    //         key={index}
    //         to={item.path}
    //         style={{
    //           display: "flex",
    //           justifyContent: "space-between",
    //           alignItems: "center",
    //           padding: "18px",
    //           marginBottom: "12px",
    //           borderRadius: "12px",
    //           border: "1px solid rgba(255, 255, 255, 0.92)",
    //           textDecoration: "none",
    //           // background: "#fff",
    //           boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    //           transition: "0.3s",
    //         }}
    //       >
    //         {/* Left */}
    //         <div
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             gap: "12px",
    //           }}
    //         >
    //           <div
    //             style={{
    //               width: "45px",
    //               height: "45px",
    //               borderRadius: "10px",
    //               display: "flex",
    //               alignItems: "center",
    //               justifyContent: "center",
    //               fontSize: "20px",
    //               background: item.color,
    //               color: item.textColor,
    //             }}
    //           >
    //             {item.icon}
    //           </div>

    //           <div>
    //             <h6
    //               style={{
    //                 margin: 0,
    //                 fontWeight: "600",
    //                 color: "#6366f1",
    //               }}
    //             >
    //               {item.title}
    //             </h6>
    //             <small
    //               style={{
    //                 color: "#6b7280",
    //               }}
    //             >
    //               {item.desc}
    //             </small>
    //           </div>
    //         </div>

    //         {/* Arrow */}
    //         <i
    //           className="bi bi-chevron-right"
    //           style={{
    //             color: "#9ca3af",
    //             fontSize: "18px",
    //           }}
    //         ></i>
    //       </Link>
    //     ))}
    //   </div>
    // </div>
  );
}

export default AdminSetting;